module.exports = __webpack_public_path__ + "img/CHEVROLET.bd28d861.webp";